module.exports = __webpack_public_path__ + "img/share-poster-copy.45480262.png";